export const getAllFlowVariables = () => {
  let flowVariables: string[] = []
  flowVariables = flowVariables.concat(flowShopVariables)
  flowVariables = flowVariables.concat(flowLocationVariables)
  flowVariables = flowVariables.concat(flowServiceVariables)
  flowVariables = flowVariables.concat(flowResourceVariables)
  flowVariables = flowVariables.concat(flowCustomerVariables)
  flowVariables = flowVariables.concat(flowAppointmentVariables)
  flowVariables = flowVariables.concat(flowBackwardCompatibilityVariables)
  return flowVariables
}

export const flowShopVariables = [
  '{{ShopId}}',
  '{{StoreTimezone}}'
]

export const flowLocationVariables = [
  '{{Location.ID}}',
  '{{Location.Name}}',
  '{{Location.Email}}',
  '{{Location.Phone}}',
  '{{Location.Description}}',
  '{{Location.Image}}',
  '{{Location.Timezone}}',
  '{{Location.Country}}',
  '{{Location.State}}',
  '{{Location.City}}',
  '{{Location.Address}}',
  '{{Location.ZipCode}}',
  '{{Location.Latitude}}',
  '{{Location.Longitude}}',
]

export const flowServiceVariables = [
  '{{ServiceName}}',
  '{{ServiceDescription}}',
  '{{ServiceImageURL}}',
  '{{ServiceDuration}}',
  '{{ServiceLocation}}',
  '{{ServicePrice}}',
  '{{ServiceURLHandle}}',
]

export const flowResourceVariables = [
  '{{#each Resources}}',
  '{{ID}}',
  '{{Type}}',
  '{{Name}}',
  '{{Email}}',
  '{{Image}}',
  '{{/each}}',
]

export const flowCustomerVariables = [
  '{{Shopify.CustomerID}}',
  '{{CustomerName}}',
  '{{CustomerFirstName}}',
  '{{CustomerLastName}}',
  '{{CustomerEmail}}',
  '{{CustomerPhone}}',
  '{{CustomerTimezone}}',
  '{{CustomerBillingPhone}}',
  '{{CustomerManagementLink}}',
]

export const flowAppointmentVariables = [
  '{{AppointmentID}}',
  '{{AppointmentCreatedAt}}',
  '{{AppointmentUpdatedAt}}',
  '{{DateTime}}',
  '{{VariantTitle}}',
  '{{Quantity}}',
  '{{Locale}}',
  '{{OrderID}}',
  '{{Shopify.OrderID}}',
  '{{LineItemID}}',
  '{{Shopify.LineItemID}}',
  '{{#each LineItemProperties}}',
  '{{name}}',
  '{{value}}',
  '{{/each}}',
]

export const flowBackwardCompatibilityVariables = [
  '{{TeamMemberName}}',
  '{{TeamMemberBio}}',
  '{{TeamMemberEmail}}',
  '{{TeamMemberPhone}}',
  '{{TeamMemberDescription}}'
]
